var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../../js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["core/templates/contentful/shoppable/shoppable-product-indicator.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
output += "<svg class=\"c-shoppable-image__indicator\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 30 30\"\n    aria-label=\"";
output += runtime.suppressValue((lineno = 1, colno = 18, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["shoppable-image_svg-label-indicator"])), env.opts.autoescape);
output += "\">\n    <style>\n        .shoppable-indicator-cls-1 { fill: #fff; }\n        .shoppable-indicator-cls-2 { fill: #5c5c5f; }\n    </style>\n    <title id=\"shoppable-image-indicator\">";
output += runtime.suppressValue((lineno = 6, colno = 44, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["shoppable-image_svg-label-indicator"])), env.opts.autoescape);
output += "</title>\n\n    <path class=\"shoppable-indicator-cls-1\" d=\"M15.781,7.985,6.848,16.917l6.27,6.269,8.929-8.929-.361-5.991Zm3.808,3.768a1.077,1.077,0,1,1,0-1.523A1.077,1.077,0,0,1,19.589,11.753Z\"></path>\n    <path class=\"shoppable-indicator-cls-1\" d=\"M15,0A15,15,0,1,0,30,15,15,15,0,0,0,15,0ZM13.118,24.6,5.434,16.917l9.952-9.952,7.246.345.44,7.336Z\"></path>\n    <path class=\"shoppable-indicator-cls-2\" d=\"M15.386,6.965,5.434,16.917,13.118,24.6l9.954-9.954-.44-7.336ZM13.118,23.186l-6.27-6.269,8.933-8.932,5.9.281.361,5.991Z\"></path>\n    <circle class=\"shoppable-indicator-cls-2\" cx=\"18.828\" cy=\"10.991\" r=\"1.076\"/>\n</svg>\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["core/templates/contentful/shoppable/shoppable-product-indicator.j2"] , dependencies)